module.exports = __webpack_public_path__ + "img/star_dark.23b7f28f.png";